export const MESH_CONTEXT_SYMBOL = Symbol('isMeshContext');
export const MESH_API_CONTEXT_SYMBOL = Symbol('isMeshAPIContext');
